<template>
    <el-dialog width="500px" :visible.sync="dialogVisible" :append-to-body="true" @close="dialogClose">
        <div slot="title" class="column-config_title">
            {{ dialogTitle }}
        </div>
        <div class="upload-warehouse-container">
            <el-form class="form-item" ref="form" :model="form" :rules="rules" :label-width="'80px'">
                <el-form-item label="上传附件" prop="fileName" class="upload-item dialog-item">
                    <el-input
                        v-model="form.fileName"
                        placeholder="点击上传附件"
                        class="input-class"
                        readonly></el-input>

                    <el-tooltip
                        class="item"
                        effect="dark"
                        :disabled="form.fileName ? false : true"
                        :content="form.fileName"
                        placement="top-start">
                        <upload
                            :uploadDisplayType="uploadDisplayType"
                            :accept="uploadAccept"
                            :flag="flag"
                            class="upload-item-icon"
                            :sizeLimit="sizeLimit"
                            :fileTypeReg="fileTypeReg"
                            @uploadSuccess="callback"></upload>
                    </el-tooltip>
                    <span @click="onPreview('normal')" class="preview_btn">预览</span>
                </el-form-item>
            </el-form>
            <div class="upload-bottom">
                <div class="ql-upload-tip">文件不超过{{ sizeLimit }}MB,支持 {{ uploadFile }}上传</div>
                <div v-if="!qualificationName.includes('其他附件')">
                    <el-button type="primary" :loading="tempLoading" @click="handleTemp">下载模板</el-button>
                </div>
            </div>
            <preview
                v-if="attachmentShow"
                :attachmentList="attachmentList"
                :attachmentShow.sync="attachmentShow"
                :rowData="rowData"></preview>
            <div slot="footer" class="dialog-footer">
                <el-button @click="handleClose">取 消</el-button>
                <el-button type="primary" @click="save">确 定</el-button>
            </div>
        </div>
    </el-dialog>
</template>
<script>
import { insertUpdate } from '../../../../../api/warehouse.js'
import { dictWithUrl } from '@/components/lots/api'
import { OSS_FILE_MAX_SIZE } from '../../../../../constant/constant.js';
import upload from '../../../../../components/upload/Index.vue'
import preview from '../../../../../components/viewAttachment.vue'
import { leaseFileTplQuery } from '../../../../../api/warehouse.js'
export default {
    components: { upload, preview },

    data() {
        return {
            dialogVisible: false,
            loading: false,
            tempLoading: false,
            form: {
                fileName: '',
                fileUrl: '',
                fileId: '',
                id: '',
            },
            rules: {
                fileName: [{ required: true, message: '请上传附件' }],
            },
            uploadDisplayType: 'icon',
            uploadAccept: 'image/*,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.pdf',
            uploadFile: 'word/pdf/ppt/excel/jpg/png',
            flag: {},
            sizeLimit: OSS_FILE_MAX_SIZE,
            dialogTitle: '上传附件',
            fileTypeReg: /\.(jpg|jpeg|png|pdf|doc|docx|xls|xlsx|ppt|pptx|pdf|)$/,
            qualificationName: '',
            qualificationProp: '',
            whCode: '',
            attachmentShow: false,
            attachmentList: [],
            rowData: {},
            templateData: {},
            bigForm: null,
        }
    },
    methods: {
        show(title, row, form) {
            const { whCode, leaseFileList, prop } = row
            this.qualificationProp = prop
            this.bigForm = form
            this.dialogVisible = true
            this.dialogTitle = `上传${title}`
            this.qualificationName = title
            this.whCode = whCode
            this.templateData = {}
            this.form.fileName = ''
            this.form.fileUrl = ''
            this.form.fileId = ''
            this.form.id = ''
            this.rules.fileName[0].required = true
            if (title.includes('其他附件')) {
                this.uploadAccept = 'image/*,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.pdf,.ZIP,.RAR,.7z'
                this.uploadFile = 'word/pdf/ppt/excel/jpg/png/ZIP/RAR/7z'
                this.fileTypeReg= /\.(jpg|jpeg|png|pdf|doc|docx|xls|xlsx|ppt|pptx|zip|rar|7z|)$/;

            } else {
                this.uploadAccept = 'image/*,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.pdf'
                this.uploadFile = 'word/pdf/ppt/excel/jpg/png'
                this.fileTypeReg= /\.(jpg|jpeg|png|pdf|doc|docx|xls|xlsx|ppt|pptx|)$/;
            }
            if (Array.isArray(leaseFileList) && leaseFileList.length > 0) {
                for (const item of leaseFileList) {
                    if (item.qualificationName === title) {
                        this.form.id = leaseFileList[0].id
                        break
                    }
                }
            }

            if (title.includes('其他附件')) {
                this.rules.fileName[0].required = false
                return false
            }
            this.getTemplate()
        },
        onPreview() {
            this.rowData = {
                downUrl: this.form.fileUrl,
                fileName: this.form.fileName,
                fileId: this.form.fileId,
            }
            this.attachmentList = this.allAttachmentList
            this.attachmentShow = true
        },
        save() {
            this.$refs.form.validate(valid => {
                if (valid) {
                    const { leaseFileList } = this.bigForm
                    let params = {
                        fileName: this.form.fileName,
                        fileUrl: this.form.fileUrl,
                        fileId: this.form.fileId,
                        qualificationName: this.qualificationName,
                        qualificationTypeCode: this.whCode,
                        qualificationType: '租仓方案',
                    }
                    if(!(this.form.fileUrl&&this.form.fileId)){
                        this.dialogVisible = false
                        return false
                    }
                    let flag = this.hasAttachment()
                    if (flag && Array.isArray(leaseFileList) && leaseFileList.length > 0) {
                        for (const item of leaseFileList) {
                            if (item.qualificationName === this.qualificationName) {
                                item.fileName = this.form.fileName
                                item.fileUrl = this.form.fileUrl
                                item.fileId = this.form.fileId
                                this.bigForm[this.qualificationProp] = this.form.fileName
                                break
                            }
                        }
                    } else {
                        this.$set(this.bigForm, this.qualificationProp, this.form.fileName)
                        if (Array.isArray(leaseFileList)) {
                            this.bigForm.leaseFileList.push(params)
                        } else {
                            this.bigForm.leaseFileList = [params]
                        }
                    }
                    this.dialogVisible = false
                }
            })
        },
        hasAttachment() {
            const { leaseFileList } = this.bigForm
            let flag = false
            if (Array.isArray(leaseFileList) && leaseFileList.length > 0) {
                for (const item of leaseFileList) {
                    if (item.qualificationName === this.qualificationName) {
                        flag = true
                        break
                    }
                }
            }
            return flag
        },
        getTemplate() {
            leaseFileTplQuery({ localFileName: `${this.qualificationName}模板` }).then(res => {
                if (res && +res.code === 0) {
                    if (Array.isArray(res.data) && res.data.length > 0) {
                        this.templateData = res.data[0]
                    }
                }
            })
        },
        handleClose() {
            this.dialogVisible = false
        },
        callback(data) {
            if (data.data.code === '0') {
                this.$message.success('附件上传成功')
                this.form.fileName = data.data.data.localFileName
                this.form.fileUrl = data.data.data.downUrl
                this.form.fileId = data.data.data.id
            } else {
                this.$message.warning('上传失败')
            }
        },

        dialogClose() {
            this.page = {
                pageSize: 10,
                pageNo: 1,
            }
        },
        handleTemp() {
            let row = this.templateData
            const downloadUrl = row.downUrl
            if (!downloadUrl) {
                this.$message.warning('下载链接有问题')
                return
            }
            const a = document.createElement('a')
            a.style.display = 'none'
            a.download = row.localFileName
            a.href = downloadUrl
            a.click()
        },
    },
    mounted() {
    },
}
</script>

<style lang="less">
.upload-warehouse-container {
    .upload-item-icon {
        position: absolute;
        top: 2px;
        z-index: 9;
        width: 260px;
        height: 28px;
        font-size: 16px;
        color: #33c9cc;
    }

    .el-upload {
        width: 100%;
        height: 30px;
        text-align: right;
    }

    .input-class {
        width: 260px;

        .el-input__inner {
            padding-right: 27px;
        }
    }

    .preview_btn {
        margin-left: 10px;
        text-decoration: underline;
        color: #33c9cc;
        cursor: pointer;
    }

    .dialog-footer {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        margin-top: 20px;
    }

    .upload_icon {
        position: relative;
        top: -2px;
        left: -5px;
    }

    .el-form-item {
        margin-bottom: 10px;
    }

    .upload-bottom {
        margin: 18px 0 0 22px;
    }

    .ql-upload-tip {
        margin-bottom: 15px;
    }
}

.column-config_title {
    small {
        margin-left: 25px;
    }
}
</style>
